import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import CustomButton from "../ui/CustomButton";
import { colorVariables } from "../../utils/colorVariable";
import { ModalAction, ModalVariant } from "../../types";

interface ModalActionsProps {
  actions: ModalAction[];
  additional?: ReactNode;
}

const getButtonStyles = (variant: ModalVariant = "primary") => {
  const styles = {
    primary: {
      bgcolor: colorVariables.primary,
      customColor: "#fff",
    },
    secondary: {
      bgcolor: colorVariables.black,
      customColor: colorVariables.lightWhite,
      border: `1px solid ${colorVariables.darkGreen}`,
    },
    danger: {
      bgcolor: colorVariables.red,
      customColor: "#fff",
    },
    info: {
      bgcolor: colorVariables.blue,
      customColor: "#fff",
    },
    warning: {
      bgcolor: colorVariables.orange,
      customColor: "#fff",
    },
    success: {
      bgcolor: colorVariables.darkGreen,
      customColor: "#fff",
    },
  };

  return styles[variant];
};

const ModalActions: React.FC<ModalActionsProps> = ({ actions, additional }) => {
  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      flex={1}
      alignItems="center"
      gap={1}
      flexWrap="wrap"
      minWidth={0}
    >
      <Box sx={{ minWidth: 0 }}>{additional}</Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 1,
          flexWrap: "wrap",
          ml: "auto",
        }}
      >
        {actions.map(
          (action, index) =>
            !action.isHide && (
              <CustomButton
                background={action.background}
                key={`${action.text}-${index}`}
                text={action.text}
                onClick={action.onClick}
                disabled={action.disabled}
                startIcon={action.icon}
                {...getButtonStyles(action.variant)}
                loading={action.loading}
              />
            )
        )}
      </Box>
    </Box>
  );
};

export default ModalActions;
